import { render } from "./completed-visits.vue?vue&type=template&id=4d674dbe&ts=true"
import script from "./completed-visits.vue?vue&type=script&lang=ts"
export * from "./completed-visits.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__